export const capitalize = (value: string): string => {
  const normalized = value.trim()
  return normalized ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : ''
}

export const formatDate = (value: string | Date, includeTime = false): string => {
  const date = value instanceof Date ? value : new Date(value)

  if (Number.isNaN(date.getTime())) return ''

  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    ...(includeTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  }).format(date)
}
